import * as GC from '@grapecity/spread-sheets';
import * as SheetFunctions from '@helpers/spread/sheet-functions';
import { ROW_HEIGHT, COL_WIDTH } from './results-spread-config';
import { getFont } from '@shared/spreadsheet/spreadsheet-config';
import { ResultsetItem } from '@models/resultset-item';

let currentRow: number;
let spread: GC.Spread.Sheets.Workbook;

// Summary View
export function createReportSummary(workbook: GC.Spread.Sheets.Workbook, resultsList: ResultsetItem[]) {
  spread = workbook;
  currentRow = 0;
  const sheet: GC.Spread.Sheets.Worksheet = new GC.Spread.Sheets.Worksheet('Summary');

  sheet.options.isProtected = true;
  sheet.defaults.rowHeight = ROW_HEIGHT + 3;
  sheet.defaults.colWidth = COL_WIDTH;
  let row = 1;
  let cell = sheet.getCell(row, 0, GC.Spread.Sheets.SheetArea.viewport);
  cell.width(200);
  cell.value('Scope');
  cell.font(getFont('xx-lg', true));
  SheetFunctions.centerAndWrapCell(spread, sheet, row, 0);

  row++;
  sheet.setColumnWidth(0, COL_WIDTH * 3, GC.Spread.Sheets.SheetArea.viewport);
  cell = sheet.getCell(row, 0, GC.Spread.Sheets.SheetArea.viewport);
  cell.value(
    // tslint:disable-next-line:max-line-length
    'The following document details the liquidity stress testing scenarios and assumptions utilized for the Institution.\nAll liquidity scenarios project a 12-month forecast, utilizing cash flows from the ALM model.'
  );

  cell.font(getFont('lg'));
  SheetFunctions.centerAndWrapCell(spread, sheet, row, 0);
  row += 2;

  if (resultsList.length > 0) {
    resultsList
      .filter(h => !h.Hidden)
      .forEach(resultset => {
        if (resultset.Results) {
          cell = sheet.getCell(row, 0, GC.Spread.Sheets.SheetArea.viewport);
          cell.value(resultset.ScenarioName);
          cell.font(getFont('xx-lg', true));
          SheetFunctions.centerAndWrapCell(spread, sheet, row, 0);
          row++;
          cell = sheet.getCell(row, 0, GC.Spread.Sheets.SheetArea.viewport);
          cell.value(resultset.Description);
          cell.font(getFont('lg'));
          SheetFunctions.centerAndWrapCell(spread, sheet, row, 0);
          row += 2;
        }
      });
  }
  return sheet;
}
